import IconCheck from "@/app/(components)/generics/Icons/IconCheck";

import { UStyles } from "@/app/utils/UStyles";
import styles from "./CheckboxInput.module.css";

type Props = {
  label?: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  radio?: boolean;
};

export default function CheckboxInput(props: Props) {
  const { label, checked, onToggle, radio } = props;

  return (
    <div
      className={styles.container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle(!checked);
      }}
    >
      <span
        className={UStyles.classNames(
          styles.check,
          radio ? styles.radio : "",
          checked ? styles.checked : "",
        )}
      >
        {!radio && <IconCheck />}

        {radio && checked && <span className={styles.radioChecked}></span>}
      </span>

      {label && <p className={styles.label}>{label}</p>}
    </div>
  );
}
